import { render } from "./CompanyDocumentsWidget.vue?vue&type=template&id=0c9eab28&scoped=true"
import script from "./CompanyDocumentsWidget.vue?vue&type=script&lang=js"
export * from "./CompanyDocumentsWidget.vue?vue&type=script&lang=js"

import "./CompanyDocumentsWidget.vue?vue&type=style&index=0&id=0c9eab28&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\hrportal\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9eab28"]])

export default __exports__